import { Organization } from "../Interface/Index";
import apiClient from "./api-client.service";

class OrganizationService {
  private APIBaseUrl: string;
  private organization: Organization = {} as Organization;
  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getOrganizationData() {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/organization/details`
      );
      if (response.data) {
        this.organization = response.data as Organization;
      }
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ OrganizationService ~ getOrganizationData ~ error:",
        error
      );
    }
  }

  async getOrganizationDetails() {
    if (Object.keys(this.organization).length === 0) {
      await this.getOrganizationData();
    }
    return this.organization;
  }

  async getlogoUploadUrl(filename: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/organization/upload?filename=${filename}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ OrganizationService ~ getlogoUploadUrl ~ error:",
        error
      );
    }
  }

  async checkBasePlanExpiry(): Promise<boolean> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/subscription/check-expiry`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ OrganizationService ~ checkBasePlanExpiry ~ error:",
        error
      );
      return false;
    }
  }
}

const organizationService = new OrganizationService();

export default organizationService;
